(function () {
    SUGApp.service('integrationService', integrationService);

    integrationService.$inject=['$injector','$q','$window','sugCacheFactory','SUGUtilities'];
    function integrationService( $injector, $q, $window, sugCacheFactory, SUGUtilities) {

        var loginfactory;
        if ($injector.has('loginfactory')) {
            loginfactory = $injector.get('loginfactory');
        }

        // define service
        var service = {
            /**
             * Wrapper method to make sure an API call is made by an active, logged in user
             * If API call doesn't need to be authenticated, simply use SUGUtilities.APISyncCall
             *
             * @param {string} Method - The type of API call to make; valid values: get,post
             * @param {string} url - The http request endpoint - default set to "/SUGboxAPI.cfm?go="
             * @param {object} data - Object containing one or more arguments for the backend call
             * @param {string} goAction -the circuit action: (e.g. 'm.integrationSettings')
             * @param {long} timeout - The number of milliseconds a request can take before automatically being terminated
             *
             * ex. service.xhrLoginHandler('post', '', data, 'm.getDataById', 15000);
             */
            xhrLoginHandler: function (Method, url, data, goAction, timeout) {
                return SUGUtilities.APISyncCall(Method, url, data, goAction, timeout).then(
                    function(response){
                        var r = SUGUtilities.lowerCaseKeys(response.data);
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // check for logged out user
                            if (r.code && r.code == 1002 && loginfactory) {
                                // not logged in
                                service.myLoginInstance = service.myLoginInstance || loginfactory.getLogin(true);
                                return service.myLoginInstance.login(true).then(
                                    function () {
                                        // login succeeded, try to call self again
                                        return service.xhrLoginHandler(Method, url, data, goAction, timeout);
                                    }, function () {
                                        // login failed, just refresh the page and force a login
                                        $window.location.reload();
                                        return {};
                                    }
                                );
                            } else if (r.code && r.code === 1003) {
                                // invalid permission - direct to no access page
                                $window.location.href = '/index.cfm?go=c.NoAccess';
                                return {};
                            } else {
                                // standard error handling, not login/security related error
                                return response;
                            }
                        } else {
                            return response;
                        }
                    }
                );

            }

            // used to verify access
            , checkNPEAccess: function ( params ) {
                var deferred = $q.defer();

                //validate the arguments (even though we don't need them)
                if( typeof params.key !== 'undefined'
                    && params.key.toString().length
                    && typeof params.mid !== 'undefined'
                    && isFinite(params.mid)
                    && params.mid > 0
                ){
                    var featureCheck = false;
                    var tokenCheck = false;

                    //verify NPE feature is enabled and member has it
                    this.memberHasNPEFeature()
                    .then(function(response){
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // invalid response, return false
                            deferred.resolve(false);
                        } else {
                            // successful
                            var featresp = SUGUtilities.lowerCaseKeys(response);
                            featureCheck = featresp.data.data;
                        }

                        if(featureCheck){
                            //check member's NPE oAuth tokens by calling authorizeNPE() directly
                            service.xhrLoginHandler('post', '', 'npe', 'm.authorizeNPE', 30000)
                            .then(function(response){
                                if (SUGUtilities.ajaxResultInvalid(response)) {
                                    // invalid response, return false
                                    deferred.resolve(false);
                                } else {
                                    // successful
                                    var authresp = SUGUtilities.lowerCaseKeys(response);
                                    sugCacheFactory.set('integration_npetokens', authresp.data.data );
                                    tokenCheck = authresp.data.data.status != 'login required' ? true : false;
                                    deferred.resolve(tokenCheck);
                                }
                            });  //END authorizeNPE
                        } else {
                            // featureCheck is false
                            deferred.resolve(false);
                        }
                    }); //END memberHasNPEFeature

                } else {
                    //invalid arguments
                    deferred.reject(false);
                }
                return deferred.promise;
            }

            , getPublicIntegrations: function() {
                var integrationJSON = [
                    {
                        'name': 'Zapier',
                        'refkey': 'zapier',
                        'classname': 'zapier',
                        'active': 1,
                        'logoimage': '/images/integrations/zapier-logo.png',
                        'modalimage': '/images/integrations/zapier-modal.jpg',
                        'imagealt': 'Zapier',
                        'briefdesc': 'Use Zapier to connect SignUpGenius with hundreds of popular web services.',
                        'fulldesc': 'With SignUpGenius Pro and a Zapier account, you have the power to integrate with hundreds of other apps so they can work together.',
                        'learnmorebtn': 'Learn More',
                        'learnmorelink': '/zapier',
                        'order': 10,
                        'enabled': 1,
                        'ispopular': true,
                        'category': 'popular'
                    },
                    {
                        'name': 'Facebook',
                        'refkey': 'facebook',
                        'classname': 'facebook',
                        'active': 1,
                        'logoimage': '/images/integrations/facebook-logo.png',
                        'modalimage': '/images/integrations/facebook-logo.png',
                        'imagealt': 'Facebook',
                        'briefdesc': 'Use Facebook to log into your SignUpGenius account or to share your sign ups with your friends and followers.',
                        'fulldesc': 'Eliminate the need for a separate password by using Facebook to log into your SignUpGenius account. To share a sign up, simply post the URL link for the published sign up on your Facebook page. Participants can also share on Facebook after they sign up.',
                        'learnmorebtn': '',
                        'learnmorelink': '',
                        'order': 20,
                        'enabled': 1,
                        'ispopular': true,
                        'category': 'popular'
                    },
                    {
                        'name': 'Zoom',
                        'refkey': 'zoom',
                        'classname': 'zoom',
                        'active': 1,
                        'logoimage': '/images/integrations/zoom.png',
                        'modalimage': '/images/integrations/signupgenius-zoom.png',
                        'imagealt': 'Zoom',
                        'briefdesc': 'Add Zoom links directly to the location field of your sign up, making it easy for participants to join virtual meetings.',
                        'fulldesc': 'With our Zoom integration, you can link a Zoom meeting ID with a sign up slot or date, and then people can join video meetings directly from a sign up.',
                        'learnmorebtn': 'Learn More',
                        'learnmorelink': '/blog/now-integrated-with-zoom.cfm',
                        'order': 30,
                        'enabled': 1,
                        'ispopular': true,
                        'category': 'popular'
                    },

                    {
                        'name': 'AOL',
                        'refkey': 'aol',
                        'classname': 'aol',
                        'active': 1,
                        'logoimage': '/images/integrations/aol-logo.png',
                        'modalimage': '/images/integrations/aol-logo.png',
                        'imagealt': 'AOL',
                        'briefdesc': 'Import contacts from your AOL account into SignUpGenius.',
                        'fulldesc': 'While logged into your SignUpGenius account, you can import contacts to the Groups and Messages areas accessed on the left side of the account page. If you are creating and publishing a sign up, you may use the import feature at the final step when sending invites.',
                        'learnmorebtn': '',
                        'learnmorelink': '',
                        'order': 10,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'Constant Contact',
                        'refkey': 'constant-contact',
                        'classname': 'constant-contact',
                        'active': 1,
                        'logoimage': '/images/integrations/constant-contact-logo.png',
                        'modalimage': '/images/integrations/constant-contact-modal.jpg',
                        'imagealt': 'Constant Contact',
                        'briefdesc': 'Use our Zapier integration to create email lists in your Constant Contact account.',
                        'fulldesc': 'With SignUpGenius Pro and a Zapier account, you have the power to send information collected on a sign up to your Constant Contact account for better email marketing.',
                        'learnmorebtn': 'Learn More',
                        'learnmorelink': '/zapier',
                        'order': 20,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'GMail',
                        'refkey': 'gmail',
                        'classname': 'gmail',
                        'active': 1,
                        'logoimage': '/images/integrations/gmail-logo.png',
                        'modalimage': '/images/integrations/gmail-logo.png',
                        'imagealt': 'GMail',
                        'briefdesc': 'Import contacts from your Gmail account into SignUpGenius.',
                        'fulldesc': 'While logged into your SignUpGenius account, you can import contacts to the Groups and Messages areas accessed on the left side of the account page. If you are creating and publishing a sign up, you may use the import feature at the final step when sending invites.',
                        'learnmorebtn': '',
                        'learnmorelink': '',
                        'order': 30,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'Google Sheets',
                        'refkey': 'google-sheets',
                        'classname': 'google-sheets',
                        'active': 1,
                        'logoimage': '/images/integrations/google-sheets.png',
                        'modalimage': '/images/integrations/google-sheets-modal.jpg',
                        'imagealt': 'Google Sheets',
                        'briefdesc': 'Use our Zapier integration to export data collected on your sign up to Google Sheets.',
                        'fulldesc': 'With SignUpGenius Pro and a Zapier account, you have the ability to easily export data collected on your sign ups to Google Sheets.',
                        'learnmorebtn': 'Learn More',
                        'learnmorelink': '/zapier',
                        'order': 40,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'Mail Chimp',
                        'refkey': 'mail-chimp',
                        'classname': 'mail-chimp',
                        'active': 1,
                        'logoimage': '/images/integrations/mailchimp.jpg',
                        'modalimage': '/images/integrations/mail-chimp-modal.jpg',
                        'imagealt': 'Mail Chimp',
                        'briefdesc': 'Use our Zapier integration to create email lists in your MailChimp account from your SignUpGenius account.',
                        'fulldesc': 'With SignUpGenius Pro and a Zapier account, you have the ability to easily transfer data collected on your sign ups to your MailChimp database.',
                        'learnmorebtn': 'Learn More',
                        'learnmorelink': '/zapier',
                        'order': 50,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'Salesforce',
                        'refkey': 'salesforce',
                        'classname': 'salesforce',
                        'active': 1,
                        'logoimage': '/images/integrations/settings-salesforce.png',
                        'modalimage': '/images/integrations/salesforce-modal.jpg',
                        'imagealt': 'Salesforce',
                        'briefdesc': 'Import participant contact info collected on your sign up directly to your Salesforce account.',
                        'fulldesc': 'With SignUpGenius Pro and a Zapier account, you can easily transfer contact information collected on a sign up to your Salesforce account.',
                        'learnmorebtn': 'Learn More',
                        'learnmorelink': '/zapier',
                        'order': 60,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'Twitter',
                        'refkey': 'twitter',
                        'classname': 'twitter',
                        'active': 1,
                        'logoimage': '/images/integrations/twitter-logo.png',
                        'modalimage': '/images/integrations/twitter-logo.png',
                        'imagealt': 'Twitter',
                        'briefdesc': 'Increase exposure, volunteers, and engagement by sharing your sign ups with your Twitter followers and lists.',
                        'fulldesc': 'To share a sign up, simply post the URL link for the published sign up on your Twitter feed. Participants can also use the share button on the Thank You page after they sign up.',
                        'learnmorebtn': '',
                        'learnmorelink': '',
                        'order': 70,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'Windows',
                        'refkey': 'windows',
                        'classname': 'windows',
                        'active': 1,
                        'logoimage': '/images/integrations/windows-live-logo.png',
                        'modalimage': '/images/integrations/windows-live-logo.png',
                        'imagealt': 'Windows',
                        'briefdesc': 'Import contacts from your Windows Live (Outlook, Live, or Hotmail) account into SignUpGenius.',
                        'fulldesc': 'While logged into your SignUpGenius account, you can import contacts to the Groups and Messages areas accessed on the left side of the account page. If you are creating and publishing a sign up, you may use the import feature at the final step when sending invites.',
                        'learnmorebtn': '',
                        'learnmorelink': '',
                        'order': 80,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },
                    {
                        'name': 'Yahoo',
                        'refkey': 'yahoo',
                        'classname': 'yahoo',
                        'active': 1,
                        'logoimage': '/images/integrations/yahoo.png',
                        'modalimage': '/images/integrations/yahoo.png',
                        'imagealt': 'Yahoo',
                        'briefdesc': 'Import contacts from your Yahoo account into SignUpGenius.',
                        'fulldesc': 'While logged into your SignUpGenius account, you can import contacts to the Groups and Messages areas accessed on the left side of the account page. If you are creating and publishing a sign up, you may use the import feature at the final step when sending invites.',
                        'learnmorebtn': '',
                        'learnmorelink': '',
                        'order': 90,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'other'
                    },

                    {
                        'name': 'Fundly',
                        'refkey': 'fundly',
                        'classname': 'fundly',
                        'active': 1,
                        'logoimage': '/images/integrations/fundly400.png',
                        'modalimage': '',
                        'imagealt': 'Fundly',
                        'briefdesc': 'Fundly is a crowdfunding platform that gives individuals and groups the power to fundraise quickly, without minimum raise fees. Organizers create a unique web page to share their story and collect donations, and can share their campaign on social media.',
                        'fulldesc': '',
                        'learnmorebtn': 'Learn more about the Fundly SignUpGenius integration',
                        'learnmorelink': '/blog/now-integrated-with-fundly.cfm',
                        'order': 10,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'partners'
                    },
                    {
                        'name': 'Membership Toolkit',
                        'refkey': 'membershiptoolkit',
                        'classname': 'membershiptoolkit',
                        'active': 1,
                        'logoimage': '/images/integrations/membershiptoolkit.png',
                        'modalimage': '',
                        'imagealt': 'Membership Toolkit',
                        'briefdesc': 'Membership Toolkit is an all-in-one premier solution for small organizations. The easy-to-use software includes tools to manage your contact database, membership, directory, online sales and donations, volunteers, communications, and financials.',
                        'fulldesc': '',
                        'learnmorebtn': 'Learn more about the Membership Toolkit SignUpGenius integration',
                        'learnmorelink': '/blog/now-integrated-with-membership-toolkit.cfm',
                        'order': 20,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'partners'
                    },
                    {
                        'name': 'Remind',
                        'refkey': 'remind',
                        'classname': 'remind',
                        'active': 1,
                        'logoimage': '/images/integrations/remind.png',
                        'modalimage': '',
                        'imagealt': 'Remind',
                        'briefdesc': 'Remind is a tool designed to simplify communication between teachers, parents and students. Use Remind to distribute sign ups and send prescheduled or real-time group or individual messages.',
                        'fulldesc': '',
                        'learnmorebtn': 'Learn more about the Remind SignUpGenius integration',
                        'learnmorelink': '/blog/signupgenius-integrated-with-remind.cfm',
                        'order': 30,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'partners'
                    },
                    {
                        'name': 'Instateam',
                        'refkey': 'instateam',
                        'classname': 'instateam',
                        'active': 1,
                        'logoimage': '/images/integrations/instateam-logo.png',
                        'modalimage': '',
                        'imagealt': 'Instateam',
                        'briefdesc': "InstaTeam's advanced team management and connectivity solution automates and simplifies administrative tasks and team communication.",
                        'fulldesc': '',
                        'learnmorebtn': 'Learn more about InstaTeam',
                        'learnmorelink': 'http://www.instateam.net/',
                        'order': 40,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'partners'
                    },
                    {
                        'name': 'MobileArq',
                        'refkey': 'mobile-arq',
                        'classname': 'mobile-arq',
                        'active': 1,
                        'logoimage': '/images/integrations/mobile-arq-logo.png',
                        'modalimage': '',
                        'imagealt': 'MobileArq',
                        'briefdesc': "MobileArq is a software platform for parent organizations to manage their fundraising, directory and memberships. MobileArq's app for parents gives them their school community at their fingertips!",
                        'fulldesc': '',
                        'learnmorebtn': 'Learn more about the MobileArq SignUpGenius integration',
                        'learnmorelink': 'https://mobilearq.com/signup-genius-integration-mobilearq-platform/',
                        'order': 50,
                        'enabled': 1,
                        'ispopular': 0,
                        'category': 'partners'
                    }
                ]
    /* Basic template for adding a new integration record
                    {
                        'name': '',
                        'refkey': '',
                        'classname': '',
                        'active': 1,
                        'logoimage': '',
                        'modalimage': '',
                        'imagealt': '',
                        'briefdesc': '',
                        'fulldesc': '',
                        'learnmorebtn': 'Learn More',
                        'learnmorelink': '',
                        'order': 10,
                        'enabled': 1,
                        'ispopular': 0
                    }
    */
                return integrationJSON;
            }

             // **** BEGIN API CALLS ***** //

            , authorizeNPE: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.authorizeNPE', 30000);
            }
            , disableNPE: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.disableNPE', 15000);
            }
            , getlink: function(data) {
                return SUGUtilities.APISyncCall('post', '', data, 'c.getLink', 15000);
            }
            , getNPESignups: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.getNPESignups', 30000);
            }
            , getNPESyncTypes: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.getNPESyncTypes', 15000);
            }
            , isAppFeatureEnabled: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.isAppFeatureEnabled', 15000);
            }
            , memberHasNPEFeature: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.memberHasNPEFeature', 15000);
            }
            , saveNPESignups: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.saveNPESignups', 30000);
            }
            , saveNPESyncSettings: function(data){
                return service.xhrLoginHandler('post', '', data, 'm.saveNPESyncSettings', 15000);
            }
            , resyncNPE: function(data) {
                return service.xhrLoginHandler('post', '', data, 'm.resyncNPE', 15000);
            }
            , changeNPESyncType: function(data) {
                return service.xhrLoginHandler('post', '', data, 'm.changeNPESyncType', 15000);
            }
            , getNPESyncActivity: function(data) {
                return service.xhrLoginHandler('post', '', data, 'm.getNPESyncActivity', 15000);
            }
            , resetNPESyncJob: function(data) {
                return service.xhrLoginHandler('post', '', data, 'm.resetNPESyncJob', 15000);
            }

            // **** BEGIN SHARED FUNCTIONS ***** //

        };

        return service;
    }
}());
